import { EmptyState, Spinner } from '@vst/beam';

import styles from './ecaLoadingState.module.scss';

type EcaLoadingStateProps = {
  description?: string;
};

export const EcaLoadingState = ({ description = '' }: EcaLoadingStateProps) => {
  return (
    <div data-cy={'eca-loading-state'} className={styles['custom-empty-state']}>
      <EmptyState title={description} icon={Spinner} />
    </div>
  );
};
